import { render, staticRenderFns } from "./body_promo.vue?vue&type=template&id=dacb3f2e&scoped=true&"
import script from "./body_promo.vue?vue&type=script&lang=js&"
export * from "./body_promo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dacb3f2e",
  null
  
)

export default component.exports